module.exports = __webpack_public_path__ + "media/fonts/immaterial-ba463778377f43c6bb3708a6bf8decfc.woff2";